module.exports = __webpack_public_path__ + "img/open.e324df8c.png";